module.exports = __webpack_public_path__ + "static/projekt_indywidualny_a03-b9cd49d51dd862daffe22531cd2dc90f.jpg";